import { useState } from "react";
import { WhatsappLogo, Phone, X } from "@phosphor-icons/react";
import { motion, AnimatePresence } from "framer-motion";

export default function FloatingActions() {
    const [open, setOpen] = useState(false);
    return (
        <div className="fixed bottom-5 right-5 z-30 flex flex-col items-end gap-3">
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        className="flex flex-col gap-2 items-end"
                    >
                        <a
                            href="https://wa.me/12034666226"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="float-whatsapp"
                            className="flex items-center gap-2 bg-[#25D366] text-white pl-4 pr-3 py-2 rounded-full font-bold text-sm shadow-xl"
                        >
                            WhatsApp
                            <span className="grid place-items-center h-7 w-7 rounded-full bg-white/20">
                                <WhatsappLogo size={14} weight="bold" />
                            </span>
                        </a>
                        <a
                            href="tel:+12034666226"
                            data-testid="float-call"
                            className="flex items-center gap-2 bg-foreground text-background pl-4 pr-3 py-2 rounded-full font-bold text-sm shadow-xl"
                        >
                            Call now
                            <span className="grid place-items-center h-7 w-7 rounded-full bg-white/20">
                                <Phone size={14} weight="bold" />
                            </span>
                        </a>
                    </motion.div>
                )}
            </AnimatePresence>
            <button
                data-testid="float-toggle"
                onClick={() => setOpen((o) => !o)}
                className="h-14 w-14 grid place-items-center rounded-full bg-primary text-primary-foreground shadow-2xl hover:scale-110 transition"
                aria-label="Quick contact"
            >
                {open ? <X size={22} weight="bold" /> : <WhatsappLogo size={26} weight="bold" />}
            </button>
        </div>
    );
}
